import { render, staticRenderFns } from "./website_services.vue?vue&type=template&id=1427430c&scoped=true"
import script from "./website_services.vue?vue&type=script&lang=js"
export * from "./website_services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427430c",
  null
  
)

export default component.exports